module.exports = __webpack_public_path__ + "static/apple-icon-180x180-bcc184a8870393830dc73c5c3d3ce5aa.png";